// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"61aa5eeb","488":"85593752","607":"42dfe9a5","632":"2ba66dc9"}[chunkId] + ".chunk.js";
};